const ruleTypeList = [
  { key: 'INTEGRATED', value: 'INTEGRATED' },
  { key: 'NONINTEGRATED', value: 'NONINTEGRATED' },
];
export default ruleTypeList;
